import './user_ranking.js.coffee'

class Charts.CommentedUserRanking extends Charts.UserRanking
  url: '/monitoring/dashboard/charts/user/facebook/commented'
